import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ItemsService } from '../../../services/items.service';
import { ObjectivesData } from '../../../../shared/data_provider';
import { BaseScaffoldComponent } from '../components/base-scaffold/base-scaffold.component';
import cloneDeep from 'lodash/cloneDeep';
import { RenderedService } from '../rendered.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-outcomes',
    templateUrl: './outcomes.component.html',
    styleUrls: ['../rendered.component.scss', './outcomes.component.scss'],
    standalone: false
})
export class OutcomesComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  destroy$: Subject<boolean> = new Subject<boolean>();
  values;
  outcome = {};
  outcomes: any[] = [];
  filterd: any[] = [];
  inputFormControl: UntypedFormControl;
  constructor(
    public cdr: ChangeDetectorRef,
    private itemsService: ItemsService,
    private objectivesData: ObjectivesData,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }
  target;
  text;
  level;
  _term;
  term;
  selectedLevel;
  updateSubscription;
  originalItems;
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit() {
    console.log(this.info);
    this.values = this.item.content;
    this.originalItems = this.values;
    if (this.values) {
      this.processValues();
    }
    this.objectivesData
      .getItems(this.item.verb_capitalize)
      .pipe(take(1))
      .subscribe(items => {
        this.outcomes = items;
        this.filterList();
        this.update();
      });

    this.itemsService
      .registerReset()
      .pipe(takeUntil(this.destroy$))
      .subscribe(r => {
        if (r === 'reset') {
          this.values = cloneDeep(this.originalItems);
          this.processValues();
        } else if (r === 'saved')
          this.originalItems = cloneDeep(this.item.values);
        this.cdr.detectChanges();
      });

    this.updateSubscription = this.itemsService
      .registerItem(this.info)
      .subscribe(data => {
        this.processValues();
      });
    if (!this.data) this.data = {};
  }

  filterList(event?: any) {
    this.filterd = this.filter(event?.query || this._term);
    this.selectedVerb(this._term);
  }

  filter(value: string): any[] {
    if (!value) value = '';
    console.log(this.outcomes);
    const filterValue = value.toLowerCase();
    let fil = this.outcomes
      .map(group => {
        return {
          name: group.name,
          terms: this.filterChildren(group.terms, filterValue),
        };
      })
      .filter(group => group.terms.length);
    console.log(fil);
    return fil;
  }

  private filterChildren(children: string[], filterValue: string) {
    if (filterValue === '') return children;
    let fil = children.filter(optionValue =>
      optionValue.toLowerCase().includes(filterValue)
    );
    console.log(fil);
    return fil;
  }

  trackByFn(index, item) {
    return item.name;
  }

  processValues() {
    if (this.values && this.info && this.info.id) {
      this.text = this.values.text.value;
      this._term = this.values.term.value;
      this.target = this.values.target.value;
      if (this.values.target?.value)
        this.itemsService.getData(
          this.info,
          'target',
          this.values.target.value
        );
      if (this.values.text?.value)
        this.itemsService.getData(this.info, 'text', this.values.text.value);
      if (this.values.level?.value)
        this.itemsService.getData(this.info, 'level', this.values.level.value);
      if (this.values.term?.value)
        this.itemsService.getData(this.info, 'term', this.values.term.value);

      this.data = this.itemsService.getData(this.info);
      console.log(this.data);
      if (this.data['target']) {
        this.values.target.value = this.data['target'];
        this.target = this.values.target.value;
      }
      if (this.data['text']) {
        this.values.text.value = this.data['text'];
        this.text = this.values.text.value;
      }
      let lev;
      let current;
      if (this.data['level']) {
        this.values.level.value = this.data['level'];
        current = this.values.level.value;
        if (current && current.name) current = current.name;
        this.outcomes.forEach(set => {
          if (set.name === current) lev = set;
        });
        this.level = lev;
        this.selectedLevel = lev;
      }
      /* setTimeout(() => {
         this.setValue('level', lev.name);
       })*/
      if (this.data['term']) {
        this.values.term.value = this.data['term'];
        this._term = this.values.term.value;
      }
    } else {
      this.data = {};
    }
    this.cdr.detectChanges();
  }

  filerKeys(arr, filter) {
    if (filter && filter.length > 0) {
      return arr.filter(item => {
        return item.toLowerCase().startsWith(filter.toLowerCase());
      });
    } else {
      return arr;
    }
  }

  selectLevel(level?) {
    if (level) {
      this.selectedLevel = level;
      this.level = level;
      this.setValue('level', level.name);
    } else {
      this.selectedLevel = null;
      this.level = null;
      this.setValue('level', null);
    }
  }

  selectedVerb(term?) {
    console.log(term);
    if (term) {
      if (term.option) term = term.option.value;
      console.log(term);
      var level;
      if (term.match(/\./)) {
        level = this.outcomes[term.split(/\./)[0]];
        term = term.split(/\./)[1];
        this.term = term;
      } else level = this._findLevel(term);

      console.log(term);
      this.setValue('term', term);
      /*  if (level) {
          this.selectedLevel = level
          this.level = level;
          this.setValue('level', level.name);
        }*/
    } else {
      this.term = undefined;
      this.setValue('term', null);
    }
  }

  private _findLevel(term) {
    var foundLevel;
    this.outcomes.forEach(level => {
      if (level.terms.indexOf(term) != -1 && !foundLevel) {
        foundLevel = level;
        return false;
      }
    });
    console.log(foundLevel);
    return foundLevel;
  }

  setValue(key, value) {
    let prefix = '';
    if (this.item.paramprefix)
      prefix =
        this.item.paramprefix + (this.item.paramprefix.length > 0 ? '.' : '');
    this.itemsService.updateValue(prefix + key, value, this.info);
    this.cdr.detectChanges();
  }
}
